import { render } from "./VitrineHoraire.vue?vue&type=template&id=5dd4ab45&scoped=true"
import script from "./VitrineHoraire.vue?vue&type=script&lang=js"
export * from "./VitrineHoraire.vue?vue&type=script&lang=js"

import "./VitrineHoraire.css?vue&type=style&index=0&id=5dd4ab45&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd4ab45"]])

export default __exports__